var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classList},[_c('input',{class:_vm.inputConfig.styleClass,attrs:{"id":_vm.inputConfig.id,"name":_vm.inputConfig.name,"type":_vm.inputConfig.type,"maxlength":_vm.inputConfig.maxlength}}),_vm._v(" "),_c('label',{class:{ floated: _vm.floatLabel },attrs:{"for":_vm.inputConfig.id}},[_vm._v(_vm._s(_vm.inputConfig.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }